import { useApolloContext } from 'contexts';
import {
  useGetCurrentUserDefaultRolesForTenantDashboardShellQuery,
  UserDefaultRoleSlug,
} from 'generated/graphql';

export type UseIsAdmin = {
  isAdmin: boolean;
  loading: boolean;
};

/**
 * Whether the current viewer holds the org-wide admin role, from the viewer's
 * default role slugs on `getCurrentUserAndOrgs`. robin-api derives the `admin`
 * slug from the legacy `management_level >= 9001` check (and keeps both
 * stores in sync), so this matches the legacy dashboard's
 * `OrganizationService.isAdmin` — the org-wide "Admin" role, not the
 * auto-generated per-building "office admin" roles.
 *
 * AuthContext already runs this query, so consumers resolve from the Apollo
 * cache, and the tenant-scoped client resets it on org switch.
 */
export const useIsAdmin = (): UseIsAdmin => {
  const { tenantId } = useApolloContext();

  const { data, loading } =
    useGetCurrentUserDefaultRolesForTenantDashboardShellQuery({
      skip: !tenantId,
    });

  const isAdmin =
    data?.getCurrentUserAndOrgs?.userDefaultRoleSlugsForCurrentTenant?.includes(
      UserDefaultRoleSlug.Admin
    ) ?? false;

  return { isAdmin, loading };
};
